"use client"
import type { ChainIdentifier } from "@opensea/graphql"
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider"
import { useChainsQueryParam } from "@/hooks/query-param/use-chains-query-param"
import { useCollectionSlugsQueryParam } from "@/hooks/query-param/use-collection-slugs-query-param"
import { useSearchQueryQueryParam } from "@/hooks/query-param/use-search-query-query-param"
import { useStatusQueryParam } from "@/hooks/query-param/use-status-query-param"

type Filter = {
  collectionSlugs?: string[]
  chain?: ChainIdentifier
  query?: string
  isListed?: boolean
  isHidden?: boolean
}

export function useProfileItemsFilters() {
  const { statuses } = useStatusQueryParam()
  const isOwnProfileAddress = useIsOwnProfileAddress()
  const { searchQuery } = useSearchQueryQueryParam()
  const { collectionSlugs } = useCollectionSlugsQueryParam()
  const { chain } = useChainsQueryParam()

  const f: Filter = {}
  if (collectionSlugs.length) {
    f.collectionSlugs = collectionSlugs
  }
  if (chain) {
    f.chain = chain
  }
  if (statuses.includes("listed")) {
    f.isListed = true
  }
  if (statuses.includes("notListed")) {
    f.isListed = false
  }

  if (isOwnProfileAddress && statuses.includes("hidden")) {
    f.isHidden = true
  }

  if (searchQuery) {
    f.query = searchQuery
  }

  if (Object.keys(f).length === 0) {
    return undefined
  }

  return f
}
